import React from 'react'

import { CustomCellRendererProps } from 'ag-grid-react'

import { Combobox, ComboboxChip, ComboboxChips, ComboboxValue } from '@fortem-monorepo/react-ui'

export const TagsCellRenderer: React.FC<CustomCellRendererProps> = (params) => {
  const originalValue = params.value

  if (originalValue && Array.isArray(originalValue)) {
    return <TagsRendererComponent value={originalValue} />
  }

  return <>{params?.getValue?.()}</>
}

export interface TagsRendererComponentProps {
  value: string[]
}

export const TagsRendererComponent: React.FC<TagsRendererComponentProps> = ({ value }) => {
  const [shrink, setShrink] = React.useState(false)
  const chipsRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const parent = chipsRef.current?.parentElement
    let observer: ResizeObserver | null = null

    if (parent) {
      observer = new ResizeObserver((entries) => {
        const entry = entries?.[0]
        const parentHeight = entry.target.clientHeight
        const chipsHeight = chipsRef?.current?.clientHeight ?? 0
        setShrink(chipsHeight > parentHeight)
      })

      observer.observe(parent)
    }

    return () => {
      observer?.disconnect()
    }
  }, [])

  return (
    <Combobox>
      <ComboboxChips
        ref={chipsRef}
        className={
          'shadow-none border-none p-0 w-full min-h-full! m-0 inline-flex items-center gap-2 h-full!'
        }
      >
        {shrink ? (
          <>
            {value.slice(0, 1).map((value: string) => (
              <Chip value={value} key={value} />
            ))}
            <Chip value={`${value.slice(1).length}+ more`} />
          </>
        ) : (
          <ComboboxValue>
            {value.map((value: string) => (
              <Chip value={value} key={value} />
            ))}
          </ComboboxValue>
        )}
      </ComboboxChips>
    </Combobox>
  )
}

interface ChipProps {
  value: string
}

const Chip: React.FC<ChipProps> = ({ value }) => {
  return (
    <ComboboxChip value={value} className={'*:data-[slot=combobox-chip-remove]:hidden px-1.5!'}>
      {value}
    </ComboboxChip>
  )
}
